import React from 'react';
import Dialog from '@/components/resource-apply-dialog';
import DialogPin from '@/components/resource-pin-dialog';
import DialogCms from '@/components/resource-cms-dialog';
import { formateTimeStamp } from '@/common/utils';

const ref = React.createRef();
const pinref = React.createRef();
const cmsRef = React.createRef();
export default class Dialogcms extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      resourceName: '',
      startTme: '',
    };
  }

  checkDialog = (dialogParam) => {
    if (dialogParam.resourceFirstType === '1') {
      cmsRef.current.showModal(
        dialogParam.planCode,
        dialogParam.resourceId,
        dialogParam.resourceName,
        formateTimeStamp(dialogParam.startTime)
      );
    } else if (dialogParam.resourceFirstType === '0') {
      // 失败的提示
      if (!dialogParam.pin || !dialogParam.monetizedLevel) {
        ref.current.showModal(
          dialogParam.planCode,
          dialogParam.resourceId,
          dialogParam.pin,
          dialogParam.monetizedLevel
        );
      } else {
        pinref.current.showModal(
          dialogParam.planCode,
          dialogParam.pin,
          dialogParam.resourceId,
          dialogParam.resourceName,
          formateTimeStamp(dialogParam.startTime),
          dialogParam.monetizedLevel
        );
      }
    }
  };

  render() {
    return (
      <div>
        <Dialog ref={ref} onSuccess={this.props.onSuccess} onFailed={() => {}} />
        <DialogPin ref={pinref} onSuccess={this.props.onSuccess} onFailed={() => {}} />
        <DialogCms ref={cmsRef} onSuccess={this.props.onSuccess} onFailed={() => {}} />
      </div>
    );
  }
}
